import React from 'react';
import {
  Card,
  Modal,
  Row,
  Col,
  Button,
  Label,
} from 'reactstrap';
import moment from 'moment';

const ModalLog = (props) => {
  const {
    modalLogControl,
    setModalLogControl,
  } = props;

  const handleClose = () => {
    setModalLogControl({ ...modalLogControl, open: false });
  };

  if (!modalLogControl.open) {
    return null;
  }
  return (
    <Modal isOpen={modalLogControl.open} toggle={handleClose}>
      <Card style={{ padding: 5, minWidth: window.innerWidth < 350 ? null : 300 }}>
        <Row style={{ marginBottom: 10 }} className="d-flex justify-content-end">
          <Col xs="auto">
            <Button close onClick={handleClose} />
          </Col>
        </Row>
        <Row style={{ marginBottom: 10 }} className="d-flex justify-content-center">
          <Col lg={12}>
            <Label>{`Log ID: ${modalLogControl.action.id} - ${modalLogControl.action.description}`}</Label>
          </Col>
        </Row>
        <Col style={{ marginTop: 5 }}>
          {renderLogList()}
        </Col>
      </Card>
    </Modal>
  );

  function renderLogList() {
    const getActionText = (actionText = '') => {
      switch (actionText) {
        case 'CREATE':
          return 'CADASTRO';
        case 'UPDATE':
          return 'ALTERACAO';
        case 'DELETE':
          return 'EXCLUIDO';
        default:
          return actionText;
      }
    }

    if (!modalLogControl.action.log) {
      return null;
    }

    let _list = JSON.parse(modalLogControl.action.log);
    if (_list.length <= 0) {
      return null;
    }
    return (
      <Col>
        {_list.map(l => {
          return (
            <Row key={l.date} style={{ marginBottom: 10 }} className="d-flex justify-content-center">
              <Card body style={{ backgroundColor: '#e8eced', width: '100%', maxWidth: 600 }}>
                <Row style={{ marginBottom: 5 }}>
                  <Col>
                    <Label style={{ color: 'black' }}>{`Data: ${moment(l.date).format('DD/MM/yyyy HH:mm')}`}</Label>
                  </Col>
                </Row>
                <Row style={{ marginBottom: 5 }}>
                  <Col>
                    <Label style={{ color: 'black' }}>{`Acao: ${getActionText(l.action)}`}</Label>
                  </Col>
                </Row>
                <Row style={{ marginBottom: 5 }}>
                  <Col>
                    <Label style={{ color: 'black' }}>{`Usuario: ${l.user}`}</Label>
                  </Col>
                </Row>
                <Row style={{ marginBottom: 5 }}>
                  <Col>
                    <Label style={{ color: 'black' }}>{`Observacao: ${l.obs}`}</Label>
                  </Col>
                </Row>
              </Card>
            </Row>
          )
        })}
      </Col>
    )
  }
};

export default ModalLog;
